// extracted by mini-css-extract-plugin
module.exports = {"root":"disclaimer_root__2zi1S","rootInverted":"disclaimer_rootInverted__3DeZX","container":"disclaimer_container__4i8q-"};